var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LINKS, goTo, isGBRCustomer, getCustomerMainPerson } from '@raisin/cp-utils';
import { trackEvent } from '@raisin/events-tracking';
import { EVENTS } from '../../../eventsTracking';
const isCustomerMissingFinancialInformation = (customer) => {
    var _a, _b;
    const customerMainPerson = getCustomerMainPerson(customer);
    const customerFinancialInformation = (_a = customerMainPerson === null || customerMainPerson === void 0 ? void 0 : customerMainPerson.additionalFinancialInformation) === null || _a === void 0 ? void 0 : _a.sourceOfFunds;
    return (customerMainPerson &&
        (!(customerFinancialInformation === null || customerFinancialInformation === void 0 ? void 0 : customerFinancialInformation.originOfFunds) ||
            !((_b = customerFinancialInformation === null || customerFinancialInformation === void 0 ? void 0 : customerFinancialInformation.annualIncome) === null || _b === void 0 ? void 0 : _b.code)));
};
export const shouldRedirectCustomerToUpdateFinancialInformation = (customer) => !!customer && isGBRCustomer(customer) && isCustomerMissingFinancialInformation(customer);
export const redirectCustomerToUpdateFinancialInformation = () => __awaiter(void 0, void 0, void 0, function* () {
    yield trackEvent(EVENTS.CUSTOMER_REDIRECTED_TO_SOURCE_OF_FUNDS);
    goTo(LINKS.CUSTOMER.UPDATE_FINANCIAL_INFORMATION);
});
//# sourceMappingURL=financialInformation.js.map